import React from 'react'
import { Link } from 'react-router-dom'
import addOrganizer from '../functions/addOrganizer'

export default (props) => <Link {...props} to={addOrganizer(props.to)} />